import React from 'react';
import { MinusLined, PlusLined } from '@tag/tag-icons';

import styles from './collapsible-icon.module.scss';

interface ICollapsibleIcon {
  expanded: boolean;
  onClick: () => void;
  size?: string;
}

function CollapsibleIcon({ expanded, onClick, size = '18px' }: ICollapsibleIcon) {
  const collapsibleText = expanded ? 'Collapse' : 'Expand';

  const getCollapsibleIcon = () => {
    if (expanded) {
      return <MinusLined size={size} />;
    }
    return <PlusLined size={size} />;
  };

  return (
    <div className={styles['collapse-wrapper']} onClick={onClick}>
      {getCollapsibleIcon()}
      <span className={styles['collapse-text']}>{collapsibleText}</span>
    </div>
  );

}

export default CollapsibleIcon;